<template>
  <div class>
    <div class="order-detail" v-if="isImagefinish">
      <h2>訂單</h2>
      <div class="orderdetail-wrap">
        <p class="order-number">訂單編號：{{orderDetail.orderId}}</p>
        <p class="order-established-date">成立日期：{{orderDetail.createTime}}</p>
        <p class="order-status" v-if="orderDetail.shippedTime">訂單狀態：已完成</p>
        <p class="order-status" v-else-if="orderDetail.paidTime">訂單狀態：已付款</p>
        <p class="order-status" v-else>訂單狀態：未付款</p>
        <div class="progress-bar-wrap">
          <div class="order-established">
            <p>訂單成立</p>
            <div class="order-status-bar green"></div>
            <p>{{orderDetail.createTime}}</p>
          </div>
          <div class="pay-already">
            <p>付款完成</p>
            <div class="payment-progress-bar green" v-if="orderDetail.paidTime"></div>
            <div class="payment-progress-bar red" v-else></div>
            <p>{{orderDetail.paidTime}}</p>
          </div>
          <div class="transaction-completed">
            <p>商品出貨(交易完成)</p>
            <div class="transaction-progress-bar green" v-if="orderDetail.shippedTime"></div>
            <div class="transaction-progress-bar red" v-else></div>
            <p>{{orderDetail.shippedTime}}</p>
          </div>
        </div>
        <div>
          <button
            class="btn-paid"
            v-if="isPayReplyButtonDisplay"
            @click="lightboxStartOpenControl"
          >付款回報</button>
        </div>
        <div class="order-detail-info">
          <div>
            <h4>寄送資訊</h4>
            <p>寄送地區：{{orderDetail.receiverInfo.country}}</p>
            <p>寄送地址：{{orderDetail.receiverInfo.postalCode}}{{$store.getters.getCityByZipcode(orderDetail.receiverInfo.postalCode)}}{{orderDetail.receiverInfo.address}}</p>
            <p>寄送方式：{{orderDetail.receiverInfo.sendWay}}</p>
            <p>包裹追蹤碼：{{orderDetail.postalTraceCode}}</p>
            <p>
              請點選
              <a
                target="_blank"
                href="http://postserv.post.gov.tw/pstmail/main_mail.html?targetTxn=EB500100"
              >中華郵政網站</a>做查詢
            </p>
            <p>（需點選網站左欄的國際及大陸各類郵件查詢）</p>
          </div>
          <div>
            <h4>收貨人資訊</h4>
            <p>收件人：{{orderDetail.receiverInfo.full_name}}</p>
            <p>手機：{{orderDetail.receiverInfo.phone}}</p>
            <p>電子信箱：{{orderDetail.receiverInfo.email}}</p>
          </div>
          <div>
            <h4>發票資訊</h4>
            <p>發票種類：{{orderDetail.receiverInfo.invoiceType}}</p>
            <p
              v-if="orderDetail.receiverInfo.invoiceType == '同業'"
            >同業名稱：{{orderDetail.receiverInfo.invoiceHead}}</p>
            <p v-else>抬頭：{{orderDetail.receiverInfo.invoiceHead}}</p>
            <p
              v-if="orderDetail.receiverInfo.invoiceType == '同業'"
            >同業 line ID：{{orderDetail.receiverInfo.invoiceNum}}</p>
            <p v-else>統一編號：{{orderDetail.receiverInfo.invoiceNum}}</p>
          </div>
        </div>
        <div class="ordertitle">
          <div class="item-img-title pc-display-only"></div>
          <div class="item-name-title pc-display-only">
            <p>商品名稱</p>
          </div>
          <div class="item-amount-title pc-display-only">
            <p>數量</p>
          </div>
          <div class="item-price-title pc-display-only">
            <p>金額</p>
          </div>
        </div>
        <!-- 資料驅動需添加一個div -->
        <div class="order-items" v-for="(product,index) in products" :key="index">
          <div class="item-img">
            <img v-bind:src="product.imageUrl" alt="item" />
          </div>
          <div class="item-name">
            <span>{{product.shape}}-{{product.style}}</span>
            <span>{{product.size.length}}{{product.size.unit}}{{product.size.weight}}錢{{product.size.way}}</span>
            <div>配件選擇: {{product.accessory_name === null?'無':product.accessory_name}} - TWD {{product.accessory_price=== null?'0':product.accessory_price}}</div>
          </div>
          <div class="item-amount">
            <span>數量：</span>
            <span>{{product.amount}}</span>
          </div>
          <div class="item-price">
            <span>金額：</span>
            <span>
              TWD {{singleProductSum(product.total,product.accessory_price,
              product.amount)}}
            </span>
          </div>
        </div>
        <div class="order-total">
          <div>小計</div>
          <div>TWD {{orderDetail.productTotal}}</div>
          <div>運費</div>
          <div>TWD {{orderDetail.freight}}</div>
          <div>總金額</div>
          <div>TWD {{orderDetail.sum}}</div>
        </div>
      </div>
      <div class="mobile_backNav" v-if="!isWeb">
        <i class="fa fa-angle-left"></i>
        <router-link to="/gold/member_mobile">返回會員帳號</router-link>
      </div>
    </div>
    <div class="load" v-else>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
    <section>
      <div class="lightbox payment-container" v-show="isOpen" v-body-scroll-lock="isOpen">
        <div class="lightbox-target" v-if="payInfoDisplayStatus === 'writing'">
          <div class="title">
            <h2>付款回報</h2>
          </div>
          <div class="content-container">
            <p class="payment-notice">請確實填寫、勿自行去除金額尾數，以便服務人員對帳款。</p>
            <div>
              <p>付款日期</p>
              <input type="date" v-model="specialMemberPayInfo.payment_date" />
              <p class="error-message" v-if="!specialMemberPayInfoDataVerification.payment_date">請選擇付款日期</p>
              <p>付款銀行</p>
              <input type="text" v-model="specialMemberPayInfo.payment_bank_name" />
              <p class="error-message" v-if="!specialMemberPayInfoDataVerification.payment_bank_name">請填寫付款銀行</p>
              <p>付款金額</p>
              <input type="text" v-model="specialMemberPayInfo.payment_amount" />
              <p class="error-message" v-if="!specialMemberPayInfoDataVerification.payment_amount">請填寫付款金額</p>
              <p>帳號後五碼</p>
              <input type="text" v-model="specialMemberPayInfo.payment_account_last_five" />
              <p class="error-message" v-if="!specialMemberPayInfoDataVerification.payment_account_last_five">請填寫帳號後五碼</p>
            </div>
          </div>
          <div class="btn-container">
            <button @click="sendPayInfo">送出回報</button>
          </div>
          <div class="lightbox-close gold-background-close" @click="isOpen = false">
            <img src="@/images/icon-close@2x-white.png" alt="close" />
          </div>
        </div>
        <div class="lightbox-target" v-if="payInfoDisplayStatus === 'success'">
          <div class="title">
            <h2>回報成功</h2>
          </div>
          <div class="content-container">
            <p class="payment-notice">已經收到您的付款回報，我們會盡快確認您的帳款並出貨，請隨時注意信箱或是訂單狀態。</p>
          </div>
          <div class="lightbox-close gold-background-close" @click="isOpen = false">
            <img src="@/images/icon-close@2x-white.png" alt="close" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "memberOrderDetail",
  data() {
    return {
      orderDetail: "",
      products: "",
      isWeb: true,
      isImagefinish: false,
      isOpen: false,
      payInfoDisplayStatus: "writing",
      specialMemberPayInfo: {
        payment_date: "",
        payment_bank_name: "",
        payment_amount: "",
        payment_account_last_five: ""
      },
      specialMemberPayInfoDataVerification: {
        payment_date: true,
        payment_bank_name: true,
        payment_amount: true,
        payment_account_last_five: true
      }
    };
  },
  created() {
    let id = this.$store.getters.getSingleId;
    axios({
      url: this.$store.getters.getGlobalUrl + "orders/" + id,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    })
      .then(response => {
        this.orderDetail = response.data;
        this.products = response.data.product;
        this.products.forEach(item => {
          item.size.way = this.$store.getters.getTransformWay(item.size.way);
          item.size.unit = this.$store.getters.getTransformUnit(item.size.unit);
        });
        this.baseToImg();
      })
      .catch(e => {
        this.$router.push("/gold/homepage");
      });
    this.getDeviceSize();
  },
  watch: {
    products: {
      handler() {
        if (typeof this.products !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.products.forEach(item => {
            if (item.imageUrl.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.products.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    baseToImg() {
      this.products.forEach(item => {
        axios({
          url: `${item.imageUrl}`,
          method: "get"
        })
          .then(response => {
            item.imageUrl = response.data;
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      });
    },
    getDeviceSize() {
      let size = this.$store.getters.getDeviceSize;
      if (size > 585) {
        this.isWeb = true;
      } else {
        this.isWeb = false;
      }
    },
    lightboxStartOpenControl() {
      this.isOpen = true;
      this.payInfoDisplayStatus = "writing";
    },
    async sendPayInfo() {
      let dataVerificationResult = this.dataVerification();
      if (dataVerificationResult) {
        try {
          let res = await this.$store.dispatch("specialMemberSendPayInfo", {
            id: this.$store.getters.getSingleId,
            data: this.specialMemberPayInfo
          });
          this.payInfoDisplayStatus = "success";
        } catch (e) {
          alert(`錯誤訊息:${e},請稍後再試`);
        }
      } else {
        return;
      }
    },
    dataVerification() {
      let result = true;
      for (var key in this.specialMemberPayInfoDataVerification) {
        this.specialMemberPayInfoDataVerification[`${key}`] = !(
          this.specialMemberPayInfo[`${key}`] === ""
        );
        if (!this.specialMemberPayInfoDataVerification[`${key}`]) {
          result = false;
        }
      }
      return result;
    }
  },
  computed: {
    isPayReplyButtonDisplay() {
      if (this.orderDetail === "") {
        return false;
      }
      if (this.orderDetail.isPaid === "0") {
        return true;
      } else {
        return false;
      }
    },
    singleProductSum() {
      return function(productPrice, accessoryPrice, amount) {
        if (accessoryPrice === null) {
          return productPrice;
        } else {
          return parseInt(productPrice) + accessoryPrice * amount;
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail {
  text-align: left;
  color: $secondaryDeepColor1;
  h2 {
    font-size: 35px;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin: 0;
    padding-bottom: 16px;
  }
}

.orderdetail-wrap {
  border: 1px solid $primaryDeepColor;
  padding: 16px;
  text-align: left;
  .order-number {
    font-size: 24px;
    color: $secondaryDeepColor1;
    margin: 0;
  }
  .order-established-date {
    display: none;
    @include table {
      display: block;
      margin: 0;
    }
  }
  .order-status {
    display: none;
    @include table {
      display: block;
      border-bottom: 1px solid $primaryDeepColor;
      margin-bottom: 0;
      padding-bottom: 8px;
    }
  }
  .btn-paid {
    font-weight: 600;
    line-height: 40px;
    font-size: 17px;
    width: 240px;
    color: $primaryDeepColor;
    border: 1px solid $primaryDeepColor;
    background-color: rgba(0, 0, 0, 0);
  }
}

.progress-bar-wrap {
  display: flex;
  width: 100%;
  text-align: center;
  @include table {
    display: none;
  }
  .red {
    background-color: #ff6160;
  }
  .green {
    background-color: #7ed321;
  }
  .order-established {
    width: 33.33%;

    .order-status-bar {
      height: 7px;
    }
    p {
      margin: 8px;
    }
    p:nth-child(1) {
      color: #13181c;
    }
    p:nth-child(3) {
      color: $secondaryLightColor1;
    }
  }
  .pay-already {
    width: 33.33%;
    padding-left: 7px;
    .payment-progress-bar {
      height: 7px;
    }
    p {
      margin: 8px;
    }
    p:nth-child(1) {
      color: #13181c;
    }
    p:nth-child(3) {
      color: $secondaryLightColor1;
    }
  }
  .transaction-completed {
    width: 33.33%;
    padding-left: 7px;
    .transaction-progress-bar {
      height: 7px;
    }
    p {
      margin: 8px;
    }
    p:nth-child(1) {
      color: #13181c;
    }
    p:nth-child(3) {
      color: $secondaryLightColor1;
    }
  }
}

.order-detail-info {
  color: $secondaryDeepColor1;
  font-size: 17px;
  p {
    margin: 0;
  }
  h4 {
    font-size: 17px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  a {
    color: #4a90e2;
    display: inline-block;
    text-decoration: underline;
  }
}

.ordertitle {
  display: grid;
  grid-template-columns: 2fr 3fr 0.5fr 1fr;
  grid-template-rows: auto 1fr;
  align-items: center;
  width: 100%;
  color: $secondaryDeepColor1;
  border-top: 1px solid $primaryDeepColor;
  margin-top: 16px;
  @include table {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }

  .item-img-title {
    @include table {
      display: none;
    }
  }
  .item-name-title {
    @include table {
      display: none;
    }
  }
  .item-amount-title {
    @include table {
      display: none;
    }
    p {
      text-align: center;
    }
  }
  .item-price-title {
    @include table {
      display: none;
    }
    p {
      text-align: center;
    }
  }
}

.pc-display-only {
  @include table {
    display: none;
  }
}
.order-items {
  display: grid;
  grid-template-columns: 2fr 3fr 0.5fr 1fr;
  align-items: center;
  border-bottom: 1px solid $primaryDeepColor;
  @include table {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }

  .item-name {
    margin-bottom: 8px;
    span:nth-child(1) {
      display: block;
    }
  }

  .item-img {
    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 16px;
    }
  }
  .item-amount {
    font-size: 17px;
    text-align: center;
    line-height: 31px;

    @include table {
      text-align: left;
    }
    span:nth-child(1) {
      display: none;
      @include table {
        display: initial;
      }
    }
  }
  .item-price {
    font-size: 17px;
    text-align: center;
    line-height: 31px;
    @include table {
      text-align: left;
      padding-bottom: 16px;
    }
    span:nth-child(1) {
      display: none;
      @include table {
        display: initial;
      }
    }
  }
}
.order-total {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  width: 200px;
  align-items: center;
  margin-left: auto;
  text-align: right;
  padding-top: 16px;
  font-size: 17px;
  color: $secondaryDeepColor1;

  div:nth-child(6) {
    font-size: 24px;
  }
}
a {
  display: block;
  color: $primaryDeepColor;
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    text-align: center;
  }
}
//loading
.load {
  padding-top: 120px;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1111111;
  .lightbox-target {
    max-width: 600px;
    padding: 30px 20px 60px;
    background: $secondaryColor3;
    .title {
      h2 {
        margin: 0;
        font-size: 35px;
        color: $primaryDeepColor;
      }
    }
  }
  .content-container {
    padding: 0 15%;
    text-align: left;
    font-size: 17px;
    color: $secondaryDeepColor1;
    .payment-notice {
      color: $primaryDeepColor;
    }
    p {
      margin-bottom: 0;
    }
    input {
      font-size: 17px;
      border: 1px solid $primaryDeepColor;
      padding: 10px 5px;
      border-radius: 2px;
      width: 90%;
    }
  }
  .btn-container {
    margin-top: 50px;
    button {
      @extend %button;
    }
  }
  .lightbox-close {
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .lightbox-close.gold-background-close {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $primaryDeepColor;
    box-sizing: border-box;
    padding: 8px;
    img {
      width: 20px;
    }
  }
  .error-message {
    color: red;
    margin-top: 0;
  }
}
.lightbox.payment-container {
  .lightbox-target {
    @include table {
      max-width: 450px;
      padding: 15px 15px 20px;
    }
    @include betweenPhoneTable {
      max-width: 320px;
    }
    @include phone {
      padding: 5px 10px 10px;
    }
  }
  .title {
    h2 {
      @include phone {
        font-size: 30px;
      }
    }
  }
  .content-container {
    @include phone {
      padding: 0;
    }
    p {
      @include phone {
        margin-top: 5px;
      }
    }
  }
  .btn-container {
    @include betweenPhoneTable {
      margin-top: 20px;
    }
  }
}
</style>
